import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';

const styles = {
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  },
  tableRow: {
    backgroundColor: '#fff'
  }
};

const enhance = compose();

const Main = enhance(({ classes, updateAmountHistoryList }) => {
  return (
    <div>
      <div className={classes.scrollTable} id="scrollTableId">
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>チケットID</TableCell>
              <TableCell>教室ID</TableCell>
              <TableCell>教室名</TableCell>
              <TableCell>コース名</TableCell>
              <TableCell>コースID</TableCell>
              <TableCell>利用者名</TableCell>
              <TableCell>使用日時</TableCell>
              <TableCell>修正前金額</TableCell>
              <TableCell>修正後金額</TableCell>
              <TableCell>修正日時</TableCell>
              <TableCell>操作者</TableCell>
              <TableCell>教室振込額</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {updateAmountHistoryList.map(item => {
              return (
                <TableRow className={classes.tableRow} key={item.ticketId}>
                  <TableCell>{item.ticketId}</TableCell>
                  <TableCell>{item.shopId}</TableCell>
                  <TableCell>{item.shopName}</TableCell>
                  <TableCell>{item.menuName}</TableCell>
                  <TableCell>{item.menuId}</TableCell>
                  <TableCell>{item.displayName}</TableCell>
                  <TableCell>{item.useDate}</TableCell>
                  <TableCell>
                    {item.historyDetailDtoList &&
                      item.historyDetailDtoList.length > 0 &&
                      item.historyDetailDtoList.map((amount, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <div key={`${item.ticketId}_${index}`}>
                          {amount.oldAmount !== null
                            ? amount.oldAmount.toLocaleString()
                            : ''}
                        </div>
                      ))}
                  </TableCell>
                  <TableCell>
                    {item.historyDetailDtoList &&
                      item.historyDetailDtoList.length > 0 &&
                      item.historyDetailDtoList.map((amount, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <div key={`${item.ticketId}_${index}`}>
                          {amount.newAmount !== null
                            ? amount.newAmount.toLocaleString()
                            : ''}
                        </div>
                      ))}
                  </TableCell>
                  <TableCell>
                    {item.historyDetailDtoList &&
                      item.historyDetailDtoList.length > 0 &&
                      item.historyDetailDtoList.map((amount, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <div key={`${item.ticketId}_${index}`}>
                          {amount.editedAt}
                        </div>
                      ))}
                  </TableCell>
                  <TableCell>
                    {item.historyDetailDtoList &&
                      item.historyDetailDtoList.length > 0 &&
                      item.historyDetailDtoList.map((amount, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <div key={`${item.ticketId}_${index}`}>
                          {amount.editedBy === 'SECRETARIAT'
                            ? '事務局'
                            : '参画事業者'}
                        </div>
                      ))}
                  </TableCell>
                  <TableCell>
                    {item.lastAmount !== null
                      ? item.lastAmount.toLocaleString()
                      : ''}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </div>
  );
});

export default withRouter(withStyles(styles)(Main));
